import {Store, Module, ActionContext} from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Favorites from '../entities/favorites';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface FavoritesState extends ListState<Favorites> {
    editFavorites: Favorites;
}
class FavoritesModule extends ListModule<FavoritesState, any, Favorites> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Favorites>(),
        loading: false,
        editFavorites: new Favorites(),
    };
    public actions = {
        async getAll(context: ActionContext<FavoritesState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/Favorite/GetFavorites', {params: payload.data});
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Favorites>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async delete(context: ActionContext<FavoritesState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Favorite/Delete?FavoriteIds=' + payload.data.FavoriteIds);
        },
    };
    public mutations = {
        setCurrentPage(state: FavoritesState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FavoritesState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}
const awardWinUserModule = new FavoritesModule();
export default awardWinUserModule;
